/*=========================================================================================
  File Name: moduleTodoGetters.js
  Description: Todo Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  getNetwork: (state) => (networkId) =>
    state.networks.find((network) => network.id === networkId),
  // getTodosBySection: state => (sectionId) => state.todoArray.filter((network) => network.sectionId == sectionId),
  getActiveNetwork: (state) => state.activeNetwork
};
